import React, { useEffect, useState } from "react";
import Select from "react-select";
import API from "../../services/api";
import { roles } from "../../utils/constants";
import { format, subMonths } from 'date-fns';
import { getReportLastDay, getReportMonthTimestamps } from "./reportDateUtils";

function SalesPersonwiseReport(props) {
  const {year, month, newReports, team:salesTeam} = props
  const [salesPerson, setSalesPerson] = useState(null);
  const [salesPersonName, setSalesPersonName] = useState('');
  const [team, setTeam] = useState('');
  const [allSalesPersons, setAllSalesPersons] = useState([]);
  const [salesReport, setSalesReport] = useState([]);
  const [currentDay, setCurrentDay] = useState(getDaysInMonth(year, month-1))
  const [yearReport, setYearReport] = useState([]);
  function getStartAndEndOfMonthTimestamps(year, month) {
    return getReportMonthTimestamps(year, month);
  }
   function getDaysInMonth(year, month) {
    return getReportLastDay(year, month);
  }
  const { startTimestamp, endTimestamp } = getStartAndEndOfMonthTimestamps(year, month);
  
  const FetchSalesPersons = async () => {
    try {
      let res = await API({
        url: "/reports/allsalespersons",
        method: "POST",
        responseType: "json",
        data: {team:salesTeam},
      });
      if (res.code === 200) {
        setAllSalesPersons(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const FetchSalesPersonsReports = async () => {
    try {
      let res = await API({
        url: "/reports/salespersonsreports",
        method: "POST",
        responseType: "json",
        data: {
          id: salesPerson,
          startTimestamp,
          endTimestamp,
          newReport:localStorage.getItem('role') === roles.salesperson ? true : newReports
        },
      });
      if (res.code === 200) {
        setSalesReport(res.data?.month);
        setYearReport(res.data?.year);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getTimestamp = (times) => {
    const startDate = new Date(year, month - 1, 1); 
    // Convert to timestamps (in seconds)
    const timestampFirstDayOfMonth = Math.floor(startDate.getTime() / 1000);
    return timestampFirstDayOfMonth + (times * 86400)
  };
  const CalculateTotal = (index) => {
    let targetDate = getTimestamp(index);
    const totalSpent = salesReport.reduce((sum, entry) => {
      if (entry.date === targetDate && entry.spent) {
        return sum + entry.spent;
      }
      return sum;
    }, 0);

    return totalSpent;
  };

  const CalculateOldBusiness = (index) => {
    let targetDate = getTimestamp(index);
    const totalSpent = salesReport.reduce((sum, entry) => {
      if (entry.business === 0 && entry.date === targetDate && entry.spent) {
        if(!team){
          setTeam(entry.sales_team)
        }
        return sum + entry.spent;
      }
      return sum;
    }, 0);

    return totalSpent;
  };

  const CalculateNewBusiness = (index) => {
    let targetDate = getTimestamp(index);
    const totalSpent = salesReport.reduce((sum, entry) => {
      if (entry.business === 1 && entry.date === targetDate && entry.spent) {
        return sum + entry.spent;
      }
      return sum;
    }, 0);

    return totalSpent;
  };

  const calculateAds = (index) =>{
    let targetDate = getTimestamp(index);
    const totalCount = salesReport.reduce((sum, entry) => {
      if (entry.date === targetDate && entry.ads) {
        return sum + entry.ads;
      }
      return sum;
    }, 0);
    return totalCount;
  }

  const calculateEcpm = (index) => {
    let targetDate = getTimestamp(index)
    const totalImpressions = salesReport.reduce((sum, entry) => {
      if (entry.date === targetDate && entry.impressions) {
        return sum + entry.impressions;
      }
      return sum;
    }, 0);
    let impresssions = totalImpressions;
    let total = CalculateTotal(index)
    let ecpm = (total/impresssions) * 1000
    return ((!isNaN(ecpm)&& ecpm !== Infinity) ? parseFloat(ecpm).toFixed(2) : "-")
  };
  const handleCurrentDay = ()=>{
    setCurrentDay(getDaysInMonth(year, month -1))
  }
  useEffect(() => {
    FetchSalesPersons();
  }, [props.team]);

  const CalculateColumnTotal = (type) => {
    if (salesReport.length) {
      if (type === "new_business") {
        let sum = 0;
        salesReport.map((entry) => {
          if (entry.business === 1 && entry.spent) {
            sum += parseFloat(entry.spent);
          }
        })
        return parseFloat(sum).toFixed(2);
      } else if (type === "old_business") {
        let sum = 0;
        salesReport.map((entry) => {
          if (entry.business === 0 && entry.spent) {
            sum += parseFloat(entry.spent);
          }
        })
        return parseFloat(sum).toFixed(2);
      } else if (type === "revenue") {
        let sum = 0;
        salesReport.map((entry) => {
          if (entry.spent) {
            sum += parseFloat(entry.spent);
          }
        })
        return parseFloat(sum).toFixed(2);
      } else if (type === "ecpm") {
        let ecpms = [];
        let ecpmsSum = 0;
        for (let rowIndex = 0; rowIndex < currentDay; rowIndex++) {
          let targetDate = getTimestamp(rowIndex)
          const totalImpressions = salesReport.reduce((sum, entry) => {
            if (entry.date === targetDate && entry.impressions) {
              return sum + entry.impressions;
            }
            return sum;
          }, 0);
          let impresssions = totalImpressions;
          let total = CalculateTotal(rowIndex)
          let ecpm = (total / impresssions) * 1000
          if ((!isNaN(ecpm) && ecpm !== Infinity)) {
            ecpms.push(ecpm);
          }
        }
        if (ecpms.length > 0) {
          ecpms?.map((item) => {
            ecpmsSum += item;
          })
          return (parseFloat(ecpmsSum) / (ecpms.length)).toFixed(2)
        } else {
          return 0;
        }
      }
      else if(type === "ads"){
        let sum = 0;
        salesReport.map((entry) => {
          if (entry.ads) {
            sum += (entry.ads);
          }
        })
        return sum;
      }
    }
    else {
      return 0;
    }

  };
  function getPreviousMonthsLabels(currentMonth, year) {
    const months = [];
    let date = new Date(year, currentMonth - 2, 1);
  
    for (let i = 0; i < currentMonth-1; i++) {
      months.push(format(date, 'MMM_yy'));
      date = subMonths(date, 1);
    }
  
    return months;
  }
  const getTotalSpentForMonth = (monthNumber) => {
    // Find the corresponding month in the aggregation result
    const monthData = yearReport.find(
      (item) => item._id.month === monthNumber
    );
  
    // If month data is found, return the totalSpent, else return 0
    return monthData ? monthData.totalSpent?.toFixed(2) : 0;
  };

  useEffect(() => {
    if (salesPerson) FetchSalesPersonsReports();
    handleCurrentDay()
  }, [salesPerson, year, month, newReports]);
  return (
    <>
      <h5>Select Salesperson</h5>
      <div className="d-flex gap-3">
        <Select
          className="mb-3 w-44"
          options={allSalesPersons}
          onChange={(e) => {setSalesPerson(e.value); setSalesPersonName(e.label)}}
        />
        <h6>Slected Sales Person: {salesPersonName}</h6>
      </div>
     {salesPerson? <div className="report-image">
        <h4>
          {salesPersonName}
          {"-"}
          {team}
        </h4>
        <div className="overflow-x-auto">
          <table className="table table-bordered report-table" id="saleswise-report"> 
            <thead>
              <tr>
                <th>Date</th>
                {/* <th>No.of Ads</th> */}
                <th>New Business</th>
                <th>Old Business</th>
                <th>Revenue</th>
                {/* <th>Ecpm</th> */}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: currentDay }, (_, index) => (
                <tr key={index}>
                  <td>{`${index + 1}-${month}-${year}`}</td>
                  {/* <td>{calculateAds(index)}</td> */}
                  <td title={parseFloat(CalculateNewBusiness(index)).toFixed(2)}>{Math.round(CalculateNewBusiness(index))}</td>
                  <td title={parseFloat(CalculateOldBusiness(index)).toFixed(2)}>{Math.round(CalculateOldBusiness(index))}</td>
                  <td title={parseFloat(CalculateTotal(index)).toFixed(2)}>{Math.round(CalculateTotal(index))}</td>
                  {/* <td>{calculateEcpm(index)}</td> */}
                </tr>
              ))}
              <tr className="bg-yellow-300">
                <td>Total</td>
                {/* <td>{CalculateColumnTotal("ads")}</td> */}
                <td title={CalculateColumnTotal("new_business")}>{Math.round(parseFloat(CalculateColumnTotal("new_business")))}</td>
                <td title={CalculateColumnTotal("old_business")}>{Math.round(parseFloat(CalculateColumnTotal("old_business")))}</td>
                <td title={CalculateColumnTotal("revenue")}>{Math.round(parseFloat(CalculateColumnTotal("revenue")))}</td>
                {/* <td>{CalculateColumnTotal("ecpm")}</td> */}
              </tr>
              {getPreviousMonthsLabels(month, year).map((month_label, index) => (
                <tr key={index} className="year-row">
                  <td>{month_label}</td>
                  {/* <td></td> */}
                  <td></td>
                  <td></td>
                  <td title={getTotalSpentForMonth(month-(index+1))}>{Math.round(parseFloat(getTotalSpentForMonth(month-(index+1)) || 0))}</td>
                  {/* <td></td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div> : null}
    </>
  );
}
export default SalesPersonwiseReport;
